(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["new-hero"] && !Shopify.designMode) return;
  try {
    
  class HeroSlider {
    constructor(container) {
      this.container = container;
      this.slides = Array.from(container.querySelectorAll('.hero__slide'));
      if (this.slides.length <= 1) return;

      this.autoplaySpeed = parseInt(container.dataset.autoplaySpeed) || 5000;
      this.animationSpeed = parseInt(container.dataset.animationSpeed) || 500;
      this.currentIndex = 0;
      this.interval = null;

      // Set animation speed variable
      container.style.setProperty('--animation-speed', `${this.animationSpeed}ms`);

      this.init();
    }

    init() {
      this.startAutoplay();
    }

    startAutoplay() {
      this.stopAutoplay();
      this.interval = setInterval(() => {
        this.nextSlide();
      }, this.autoplaySpeed);
    }

    stopAutoplay() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    }

    nextSlide() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    goToSlide(index) {
      this.slides[this.currentIndex].classList.remove('is-active');
      this.slides[index].classList.add('is-active');
      this.currentIndex = index;
    }
  }

  function initSliders() {
    document.querySelectorAll('.hero__slider').forEach(container => {
      if (!container.heroSlider) {
        container.heroSlider = new HeroSlider(container);
      }
    });
  }

  document.addEventListener('DOMContentLoaded', initSliders);

  if (Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.querySelector('.hero__slider')) {
        initSliders();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
